export default "__VITE_ASSET__CAPtFne___"